import { ConfigProvider } from "antd";
import { CustomThemeProvider } from "customHooks/ThemeContext";
import 'react-phone-input-2/lib/style.css'
import 'react-toastify/dist/ReactToastify.min.css';
import React, { lazy } from "react";
import { ThemeProvider } from "styled-components";
// import Testing from "pages/Testing";

const AppRoutes = lazy(() => import('routes/Routes'));

function App() {
  return (
    <React.Suspense
      fallback={
        <div
          className="h-screen w-screen bg-white dark:bg-dark130 flex items-center justify-center"
        >
          <h6>Loading...</h6>
        </div>
      }
    >
      <CustomThemeProvider>
        <ThemeProvider
          theme={
            {
              primary: "#CD580F"
            }
          }>
          <ConfigProvider
            theme={{
              token: {
                colorPrimary: "#CD580F",
                colorPrimaryActive: "#CD580F",
              },
            }}
          >
            {/* <Testing /> */}
            <AppRoutes />
          </ConfigProvider>
        </ThemeProvider>
      </CustomThemeProvider>
    </React.Suspense>
  );
}

export default App;
